export const globalVariable = {
  selectedCabinet: {},
};
